export const globalVariable = {
  selectedCabinet: {},
};
